<template>
<div class="tab">
  <div class="tab-head">
    <div class="tab-headItem" :class="{ 'tab-headItem--active': tab.isActive }"
      v-for="tab in tabs"
      @click="select(tab)">
      {{ tab.name }}
    </div>
  </div>
  <div class="tab-content">
    <slot></slot>
  </div>
</div>
</template>

<script>
export default {
  data(){ return {
    tabs: []
  }},

  methods: {
    select(selectedTab){
      this.tabs.forEach(tab => {
        tab.isActive = (tab.name === selectedTab.name);
      });
    }
  },

  mounted(){
    this.tabs = this.$children;
  }
}
</script>



// WEBPACK FOOTER //
// tabs.vue?24a677c2